module.exports = __webpack_public_path__ + "static/img/4326_phase_function_Paper_Points.010dd2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4326_phase_function_Paper_Points.png
// module id = VIwL
// module chunks = 0